import React, { FC, PropsWithChildren, ReactNode, useEffect, useRef } from 'react';
import s from './index.scss';
import { Dismiss } from '@wix/wix-ui-icons-common';
import cs from 'classnames';

interface ICustomModalProps {
  isOpen: boolean;
  onClose: () => void;
  children?: ReactNode;
  className?: string;
}

export const CustomModal: FC<PropsWithChildren<ICustomModalProps>> = ({ className, isOpen, onClose, children }) => {
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const dialog = dialogRef.current;

    if (!dialog) {
      return;
    }

    if (isOpen) {
      dialog.showModal();
    } else if (dialog.open) {
      dialog.close();
    }
  }, [isOpen]);

  const handleOverlayClick = (e: React.MouseEvent<HTMLDialogElement>) => {
    const dialog = dialogRef?.current;
    if (!dialog) {
      return;
    }

    const rect = dialog.getBoundingClientRect();
    const isInDialog =
      rect.top <= e.clientY &&
      e.clientY <= rect.top + rect.height &&
      rect.left <= e.clientX &&
      e.clientX <= rect.left + rect.width;

    if (!isInDialog) {
      onClose();
    }
  };

  return (
    <dialog ref={dialogRef} className={s.CustomModal} onClick={handleOverlayClick}>
      <div className={cs(s.CustomModal__content, className)}>
        <button className={s.CustomModal__close} onClick={onClose}>
          <Dismiss />
        </button>
        {children}
      </div>
    </dialog>
  );
};
